/**
 * Query Key Factory
 * 
 * Centralized query key definitions for TanStack Query.
 * Provides type-safe query keys for all entities.
 */
 
export interface KnowledgeFilters {
  source_type?: string;
  category_label?: string;
  tag?: string;
  limit?: number;
  offset?: number;
}
 
export interface TaskFilters {
  status?: string;
  priority?: string;
  tag?: string;
  limit?: number;
  offset?: number;
}
 
export const queryKeys = {
  // Knowledge base queries
  knowledge: {
    all: ['knowledge'] as const,
    lists: () => [...queryKeys.knowledge.all, 'list'] as const,
    list: (filters: KnowledgeFilters) => 
      [...queryKeys.knowledge.lists(), filters] as const,
    details: () => [...queryKeys.knowledge.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.knowledge.details(), id] as const,
    status: (id: string) => [...queryKeys.knowledge.all, 'status', id] as const,
    search: (query: string) => [...queryKeys.knowledge.all, 'search', query] as const,
  },
 
  // Task queries
  tasks: {
    all: ['tasks'] as const,
    lists: () => [...queryKeys.tasks.all, 'list'] as const,
    list: (filters: TaskFilters) => [...queryKeys.tasks.lists(), filters] as const,
    details: () => [...queryKeys.tasks.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.tasks.details(), id] as const,
  },
 
  // Project queries
  projects: {
    all: ['projects'] as const,
    lists: () => [...queryKeys.projects.all, 'list'] as const,
    list: () => [...queryKeys.projects.lists()] as const,
    details: () => [...queryKeys.projects.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.projects.details(), id] as const,
    workspace: (id: string) => [...queryKeys.projects.all, 'workspace', id] as const,
  },
 
  // Suggestion queries
  suggestions: {
    all: ['suggestions'] as const,
    lists: () => [...queryKeys.suggestions.all, 'list'] as const,
    list: () => [...queryKeys.suggestions.lists()] as const,
  },
 
  // Connection queries
  connections: {
    all: ['connections'] as const,
    lists: () => [...queryKeys.connections.all, 'list'] as const,
    list: () => [...queryKeys.connections.lists()] as const,
    details: () => [...queryKeys.connections.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.connections.details(), id] as const,
  },
 
  // Category queries
  categories: {
    all: ['categories'] as const,
    lists: () => [...queryKeys.categories.all, 'list'] as const,
    list: () => [...queryKeys.categories.lists()] as const,
  },
 
  // Health check queries
  health: ['health'] as const,
 
  // Profile queries
  profile: ['profile'] as const,

  // Profile proposal queries (pending profile updates awaiting approval)
  profileProposals: ['profileProposals'] as const,

  // Notification queries
  notifications: ['notifications'] as const,
};
